function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Menu } from "@headlessui/react";
import React, { Fragment, useEffect } from "react";
import SDropdownButton from "./SDropdownButton";
import { DropdownItem } from "./SDropdownItem";
import { SButton } from "../components";
const SDropdown = ({ title, ariaLabel, width = 200, elements, children, position = "right", style, className = "", wrapperClassName = "", display = "inline-block", isUnstyledItems = false, disabled = false, fixed = false, noWrap = true, buttonProps = {
    variant: "secondary",
    isMinimal: true,
    size: "lg"
} })=>{
    var _ref_current, _ref_current1;
    const widthStyle = !!width ? {
        width
    } : {
        minWidth: 150
    };
    const ref = React.useRef(null);
    const [offset, setOffset] = React.useState({
        top: 0,
        left: 0
    });
    const update = (ref)=>{
        if (ref.current) {
            setOffset({
                top: ref.current.getBoundingClientRect().bottom,
                left: ref.current.getBoundingClientRect().left
            });
        }
    };
    useEffect(()=>{
        if (typeof window === "undefined" || !fixed) return;
        const handleEvent = ()=>{
            if (ref.current) {
                setOffset({
                    top: ref.current.getBoundingClientRect().bottom,
                    left: ref.current.getBoundingClientRect().left
                });
            }
        };
        window.addEventListener("resize", handleEvent);
        window.addEventListener("scroll", handleEvent);
        return ()=>{
            window.removeEventListener("resize", handleEvent);
            window.removeEventListener("scroll", handleEvent);
        };
    }, [
        fixed
    ]);
    return /*#__PURE__*/ _jsx("div", {
        style: _object_spread({
            display
        }, style),
        className: wrapperClassName,
        children: /*#__PURE__*/ _jsxs(Menu, {
            as: "div",
            className: `relative flex-grow items-stretch ${disabled && "cursor-not-allowed"}`,
            children: [
                /*#__PURE__*/ _jsx(Menu.Button, {
                    as: "div",
                    onMouseEnter: ()=>{
                        update(ref);
                    },
                    onMouseMove: ()=>{
                        update(ref);
                    },
                    // @ts-ignore
                    ref: ref,
                    className: `h-full ${disabled ? "pointer-events-none" : ""}`,
                    style: {
                        WebkitAppearance: "unset"
                    },
                    children: children !== null && children !== void 0 ? children : /*#__PURE__*/ _jsx(SButton, _object_spread_props(_object_spread({
                        "aria-label": ariaLabel
                    }, buttonProps), {
                        children: title
                    }))
                }),
                /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx(Menu.Items, {
                        className: `
          ${fixed ? `fixed top-0 right-0` : `absolute ${position}-0 origin-top-${position}`}
          divide-y focus:outline-none z-[999] mt-1

          mr-[-1px]
          rounded-xl
          ${noWrap ? "whitespace-nowrap" : ""}
          divide-grayscale-dark
          border border-grayscale-darkest
          flex flex-col
          shadow-2xl
          shadow-grayscale-darkest
          bg-grayscale-light overflow-hidden ${className}`,
                        // TODO: measure the width of the target element
                        style: _object_spread({}, widthStyle, fixed && ref.current ? {
                            top: (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.getBoundingClientRect().bottom,
                            right: window.innerWidth - ((_ref_current1 = ref.current) === null || _ref_current1 === void 0 ? void 0 : _ref_current1.getBoundingClientRect().right)
                        } : {}),
                        children: elements.map((element, i)=>{
                            return /*#__PURE__*/ _jsx(Menu.Item, {
                                as: Fragment,
                                children: isUnstyledItems ? element : /*#__PURE__*/ _jsx(SDropdown.Item, {
                                    "aria-label": `${ariaLabel} - ${element}`,
                                    children: element
                                })
                            }, `dd-menu-${i}`);
                        })
                    })
                })
            ]
        })
    });
};
SDropdown.Item = DropdownItem;
SDropdown.Button = SDropdownButton;
export default SDropdown;
